/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onFileMetadataRecordUpdate = /* GraphQL */ `subscription OnFileMetadataRecordUpdate {
  onFileMetadataRecordUpdate {
    description
    errors {
      count
      errorDetails
      __typename
    }
    exportStatus
    fileId
    fileName
    fileSize
    headers
    lastModifiedAt
    lastModifiedBy
    operatorsProcessed
    orgId
    recordCount
    rowsProcessedList
    s3Key
    s3OutputKeys
    templateId
    uploadBy
    uploadStatus
    uploadedAt
    validationResults
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnFileMetadataRecordUpdateSubscriptionVariables,
  APITypes.OnFileMetadataRecordUpdateSubscription
>;
